
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[eventSlug]",
      function () {
        return require("private-next-pages/[eventSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[eventSlug]"])
      });
    }
  